module.exports = __webpack_public_path__ + "static/property-2@2x-3dae55d00306e0314d2bd2abe347c506.jpg";